import { useEffect, useRef } from "react";
import TopNavbar from "@common/components/TopNavbar";
import Script from "next/script";
import useStore from "@common/state";
import { HiOutlineMail } from "react-icons/hi";
import { FaSms } from "react-icons/fa";
import { useHousehold } from "@common/queries";
import { withPageAuthRequired } from "@common/middleware";
import { useBreakpoints, usePoFExperience, useRouter } from "@common/hooks";
import { ClientRoutes } from "@common/constants";
import { ADVISOR_SUPPORT_EMAIL } from "@modules/advisory-team/constants";

const AdvisorChat = () => {
  const { isMobile } = useBreakpoints();
  const { data: household } = useHousehold();
  const router = useRouter();
  const { isSidebarExpanded, isAdvisorChatOpen, setIsAdvisorChatOpen } =
    useStore();

  useEffect(() => {
    if (router.pathname === ClientRoutes.Onboarding) {
      setIsAdvisorChatOpen(false);
    }
  }, [router.pathname, setIsAdvisorChatOpen]);

  const containerRef = useRef<HTMLDivElement>(null);

  if (containerRef.current) {
    containerRef.current.style.display = isAdvisorChatOpen ? "flex" : "none";
    containerRef.current.style.top = "0px";
    containerRef.current.style.left = isMobile
      ? "0px"
      : isSidebarExpanded
      ? "288px"
      : "96px";
    containerRef.current.style.width = isMobile
      ? "100%"
      : isSidebarExpanded
      ? "calc(100% - 288px)"
      : "calc(100% - 96px)";
  }

  const { isPof } = usePoFExperience();

  return (
    <>
      <Script
        src="https://assets.calendly.com/assets/external/widget.js"
        type="text/javascript"
      />
      <div
        className="absolute flex hidden h-full flex-1 flex-col transition-all duration-300 ease-in-out"
        ref={containerRef}
      >
        <TopNavbar
          className="!z-[60]"
          title={
            isMobile
              ? "Chat"
              : !household?.primaryWealthAdvisorId
              ? "Chat with Earned"
              : "Chat with advisors"
          }
        >
          <div className="ml-2 flex flex-row items-center justify-end gap-4 lg:gap-8">
            <a href={`mailto:${ADVISOR_SUPPORT_EMAIL}`}>
              <HiOutlineMail color="inherit" size={24} />
            </a>
            {!isPof && (
              <a href="sms:+15104013515">
                <FaSms size={24} color="inherit" />
              </a>
            )}
          </div>
        </TopNavbar>
        <div className="flex flex-1 bg-white"></div>
      </div>
    </>
  );
};

export default withPageAuthRequired(AdvisorChat, {
  isOnboardingRequired: false,
});
